import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getChecklistAfterIndicatorAvailableColumns } from './api';

export const path = '/checklist/after/indicator/list';

const PageChecklistAfterIndicatorList: React.FC = (props) => {
  const ChecklistAfterIndicatorList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getChecklistAfterIndicatorAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ChecklistAfterIndicatorList {...props} />;
};

export default PageChecklistAfterIndicatorList;
